module.exports = __webpack_public_path__ + "static/img/pie_chart.0fc8aca3.png";